import type { App } from 'vue';
import type { Router } from 'vue-router';

import { sentryModel, useUserStore } from '@/shared/model';

export const withSentry = (app: App, router: Router) => {
  sentryModel.initSentry(app, router);

  const userStore = useUserStore();
  userStore
    .getUserId()
    .then(userId => sentryModel.setUser({ userId }))
    .catch((err: unknown) => {
      sentryModel.captureException(
        sentryModel.getReadableError(
          sentryModel.createCustomErrorText(
            sentryModel.errorPrefix.DEFAULT,
            'SET_USER_SENTRY',
          ),
          err as Error,
        ),
      );
    });

  app.config.errorHandler = (err, instance, info) => {
    sentryModel.captureException(
      sentryModel.getReadableError('ERR_UNHANDLED', err as Error),
      {
        extra: {
          componentName: instance?.$options.__name,
          runContext: info,
        },
      },
    );
  };

  window.FreedomWebApp.onNativeEventError = (error: Error) => {
    sentryModel.captureException(
      sentryModel.getReadableError('ERR_UNIMPLEMENTED_NATIVE_METHOD', error),
    );
  };
};
